import { useSite } from "@/contexts/SiteContext";
import SectionCta from "@/components/SectionCta";

// Fallback self-hosted (inline SVG, fără hotlink extern) când adminul n-a setat încă portretul
const PORTRAIT_FALLBACK = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='1500'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%230D1B2A'/%3E%3Cstop offset='1' stop-color='%230E7C62'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='100%25' height='100%25' fill='url(%23g)'/%3E%3C/svg%3E";

export default function About() {
  const { sectionContent } = useSite();
  const c = sectionContent("about");
  if (!c) return null;

  return (
    <section data-testid="about-section" className="py-24 lg:py-32" style={{ background: "var(--ct-surface-2)" }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <div
            className="relative aspect-[4/5] rounded-2xl overflow-hidden"
            style={{ border: "1px solid var(--ct-gold)" }}
          >
            <img
              src={c.image_url || PORTRAIT_FALLBACK}
              alt="Despre Terapeut Georgiana"
              data-img="image_url"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="lg:col-span-7 space-y-6">
          <div className="flex items-center gap-4">
            <span className="gold-rule" />
            <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Despre Georgiana"}</span>
          </div>
          <h2 data-el="title" data-field="title" className="font-serif text-4xl sm:text-5xl leading-tight">{c.title || "Despre Terapeut Georgiana"}</h2>
          {c.lead && <p data-el="lead" data-field="lead" className="text-lg italic font-serif leading-relaxed" style={{ color: "var(--ct-text)" }}>{c.lead}</p>}
          {c.body && <p data-el="body" data-field="body" className="text-base leading-relaxed" style={{ color: "var(--ct-text-muted)" }}>{c.body}</p>}
          <div className="pt-2">
            <SectionCta
              content={c}
              prefix="cta"
              fallbackText="Citește povestea mea"
              fallbackLink="/despre-mine"
              className="btn-secondary"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
